import React from "react";

const SvgFrontdoorLogomarkMono = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 334 326" {...props}>
      <g fill="currentcolor" fillRule="evenodd">
        <path d="M269.374 326V167.586c0-56.676-46.03-102.785-102.607-102.785S64.163 110.911 64.163 167.586V326H0V167.586C0 75.47 74.812.53 166.767.53c91.958 0 166.77 74.941 166.77 167.056V326h-64.163" />
        <path d="M245.917 221.303c0 15.188-12.291 27.5-27.453 27.5-15.163 0-27.455-12.312-27.455-27.5 0-15.19 12.292-27.502 27.455-27.502 15.162 0 27.453 12.313 27.453 27.502" />
      </g>
    </svg>
  );
};

export default SvgFrontdoorLogomarkMono;
